<template>
  <div class="right-details-box">
    <div class="details-box">
      <div class="details-title Overview"><img src="../assets/Overview.png" alt="概览"></div>
      <div class="details-centent">
        <dl>
          <dt>标题：</dt>
          <dd>{{webinarInfo.title}}</dd>
        </dl>
        <dl>
          <dt>日期：</dt>
          <dd>{{webinarInfo.timeToShow}}</dd>
        </dl>
      </div>
      <div class="details-count-down">
        <span class="timespan" v-show="isShowDate">距离开始还剩<span>{{countdownTimer}}</span></span>
        <span class="timespan-jrzb" v-show="isShowJumpButton" @click="linkToWebinar">进入直播</span>
        <span class="timespan-gkhf" v-show="isShowBack" @click="linkToWebinar">观看回放</span>
        <div class="timespan-yjs" v-show="isShowTextTip">
          <span>已结束</span>
          <p>我们将在72小时内生成点播视频</p>
        </div>
      </div>
    </div>
    <div class="details-box introduction-box">
      <div class="details-title"><img src="../assets/MeetingDetails.png" alt="会议详情"></div>
      <div class="details-img" v-if="isShowBack" @click="linkToWebinar"><img :src="webinarInfo.detailImg" alt=""></div>
      <div class="details-introduction" v-html="webinarInfo.intro"></div>
<!--      <div class="details-ktsImg">-->
<!--        <div v-for="item in webinarInfo.customFieldItems">-->
<!--          <img v-if="item.fieldName === 'ktsImg'" :src="item.value"/>-->
<!--        </div>-->
<!--      </div>-->
    </div>
    <div class="details-box toast-box">
      <div class="details-title">
        <img v-show="type === 'KEE'" src="../assets/Speakers.png" alt="演讲嘉宾">
        <img v-show="type === 'KTS'" src="../assets/kts/questions.png" alt="答问专家">
      </div>
      <div class="toast-list">
        <div class="toast-dl" v-for="guest in webinarInfo.speakerList">
          <div class="toast-img"><img
              v-bind:src="'http://s2-content.smarket.net.cn/index.php?mappingId='+guest.imageMapId"
              width="100%" alt=""></div>
          <div class="toast-text">
            <span v-html="guest.name"></span>
            <p v-html="guest.enterprise"></p>
          </div>
        </div>
      </div>
    </div>
    <Message v-if="isMessage && type==='KTS'" :id="messageId"  />
    <partial-loading :_is-show="isShowLoading"/>
  </div>
</template>

<script>
  import {getCookie} from '../utils/public';
  import bus from '../utils/eventBus';
  import {mapState} from 'vuex';
  import moment from 'moment';
  import 'moment/locale/zh-cn';
  import PartialLoading from './PartialLoading';
  import Message from '../components/Message'

  export default {
    name: 'WebinarDetails',
    props: ['itemInfo'],
    components: {
      PartialLoading,
      Message
    },
    data: function() {
      return {
        webinarInfo: {},
        customFormId: '',
        countdownTimer: '',
        runTimer: 0,
        isShowLoading: false,
        isMessage: false,
        messageId: '',
      };
    },
    computed: {
      ...mapState({
        instanceId: function(state) {
          return this.itemInfos.instanceId ? this.itemInfos.instanceId : state.instanceId;
        },
        userInfo: 'info',
        loginStatus: 'loginStatus',
        selectedStatus: state => state.selectedStatus ? 1 : 0,
        isForeshow: 'isForeshow',// 会议是否为预告（1预告，2回放）
        Todynum: 'Todynum', // 当前会议状态（0直播，1今日直播，2正在直播，3直播结束）
        overviewStatus: function(state) {
          return this.itemInfos.instanceId ?
            `${state.loginStatus}_${this.itemInfos.selectedStatus ? 1 : 0}_${this.itemInfos.isForeshow}_${this.itemInfos.Todynum}` :
            `${state.loginStatus}_${this.selectedStatus}_${state.isForeshow}_${state.Todynum}`;
        }
      }),
      itemInfos() {
        return this.itemInfo || {};
      },
      isWap() {
        return $(document).width() <= 750;
      },
      type(){
        return this.$store.state.type;
      },
      isShowDate: function() { // 倒计时
        return !this.isShowLoading
          && (this.overviewStatus === '1_1_1_0'
            || this.overviewStatus === '1_1_1_1');
      },
      isShowJumpButton: function() { // 进入直播
        return this.overviewStatus === '1_0_1_2'
          || this.overviewStatus === '1_1_1_2';
      },
      isShowBack: function() { // 观看回放
        return /\d_\d_2_\d/.test(this.overviewStatus);
      },
      isShowTextTip: function() { // 已结束
        return this.overviewStatus === '1_1_1_3';
      }
    },
    watch: {
      instanceId: function() {
        this.loadDetails(this.instanceId);
      },
      runTimer: function() {
        let timeDifference = moment.duration(moment(this.webinarInfo.startTime * 1000) - moment());
        let day = Number.parseInt(timeDifference.asDays().toString());
        let hour = timeDifference.hours();
        let minute = timeDifference.minutes();
        let second = timeDifference.seconds();
        this.countdownTimer = (!!day ? `${day}天` : ``) + `${hour}小时${minute}分`;
        if(day == 0 && hour == 0 && minute == 0 && second == 0)
            window.location.href = 'https://kee.smarket.net.cn/2019/index.html';
      }
    },
    created: function() {
      if (this.runTimer === 0) {
        this.startTimer();
      }
      if (this.instanceId !== 0) {
        this.loadDetails(this.instanceId);
      }
    },
    methods: {
      loadDetails: function(instanceId) { // 获取直播会议列表
        var _this = this
        this.isShowLoading = true;
        $.ajax({
          url: window.config.api.gateway.general + '/webinar/open/getWebinarInfo',
          type: 'post',
          dataType: 'json',
          data: {
            'tenantId': smarket.Config('tenantId'),
            'instanceId': instanceId,
            'includeCustomField':1
          }
        }).then((data) => {
          if(data.body.content){
            this.isMessage = false;
            this.customFormId = data.body.content.customFormId;
            this.webinarInfo = data.body.content.eventInfo;
            this.webinarInfo.customFieldItems.forEach( item => {
                if(item.fieldName=='detailImg'){
                    this.webinarInfo.detailImg = item.value;
                }else if(item.fieldName === 'messageId' && item.value != '' && this.webinarInfo.status == 3){
                  this.isMessage = true;
                  this.messageId = item.value;
                }
            })
              //新加需求 只针对这场会 时间显示是14:00-15:30
            if(this.webinarInfo.id=="69451"){
                this.webinarInfo.timeToShow = moment(this.webinarInfo.startTime * 1000).
                format('YYYY年MM月DD日，dddd，14:00-15:30');
            }
            else if(this.webinarInfo.id=="71757"){
                this.webinarInfo.timeToShow = moment(this.webinarInfo.startTime * 1000).
                format('YYYY年MM月DD日，dddd，14:00-16:00');
            }
            else{
                  if(this.type === 'KTS'){
                      this.webinarInfo.timeToShow = moment(this.webinarInfo.startTime * 1000).
                      format('YYYY年MM月DD日，dddd，15:00-16:00');
                  }else{
                      this.webinarInfo.timeToShow = moment(this.webinarInfo.startTime * 1000).
                      format('YYYY年MM月DD日，dddd，15:00-17:00');
                  }
              }

            this.runTimer++;
            setTimeout(() => {
              _this.isShowLoading = false;
              _this.$store.commit('setIsLoading', 'hide');
            }, 500);
          }else {
            _this.isShowLoading = false;
            _this.$store.commit('setIsLoading', 'hide');
          }
        });
      },
      startTimer: function() {
        setInterval(() => {
          this.runTimer++;
        }, 1000);
      },
      signUp: function() { // 线上会报名
        return $.ajax({
          url: window.config.api.gateway.general + '/api/webinar/contacts/signup',
          type: 'post',
          dataType: 'json',
          data: {
            webinarId:this.webinarInfo.parentId||this.webinarInfo.id ,
            tenantId: smarket.Config('tenantId'),
            globalUserId: getCookie('globalUserId'),
            sess: getCookie('sess'),
            formId:this.webinarInfo.parentId?'':this.customFormId,
            name: this.userInfo.name,
            memberId: this.userInfo.memberId,
             formData: [
              {
                fieldName: 'name',
                value: this.userInfo.name
              }, {
                fieldName: 'mobile',
                value: this.userInfo.mobile || this.userInfo.InternationalMobile
              }, {
                fieldName: 'email',
                value: this.userInfo.emailNew || this.userInfo.email
              }, {
                fieldName: 'company',
                value: this.userInfo.company ? this.userInfo.company : ''
              }, {
                fieldName: 'addr',
                value: this.userInfo.addr
              }, {
                fieldName: 'firstName',
                value: this.userInfo.firstName
              }, {
                fieldName: 'lastName',
                value: this.userInfo.lastName
              }, {
                fieldName: 'm_qudao',
                value: $.cookie('ARC') || ''
              }, {
                fieldName: 'f_5053',
                value: this.userInfo.f_5053[0]
              }, {
                fieldName: 'zhiwei',
                value: this.userInfo.zhiwei ? this.userInfo.zhiwei[0] : ''
              }, {
                fieldName: 'country',
                value: this.userInfo.country
              }, {
                fieldName: 'city',
                value: this.userInfo.city
              }, {
                fieldName: 'address',
                value: this.userInfo.address
              }, {
                fieldName: 'dAddress',
                value: this.userInfo.dAddress
              }, {
                fieldName: 'postCode',
                value: this.userInfo.postCode
              }, {
                fieldName: 'province',
                value: this.userInfo.province ? this.userInfo.province[0] : ''
              }
            ],
            url: window.location.href,
            referenceUrl: window.location.href,
          }
        });
      },
      linkToWebinar: function() {
        let self = this, newWindow;
        if (this.loginStatus === 0) {
          bus.$emit('showToast', '想要观看课程，请先“注册”或“登录”');
        } else if (this.loginStatus === 1 && this.selectedStatus === 0) {
          if (!this.isWap) newWindow = window.open('');
          this.signUp().then((data) => {
            if (data.body.result === 0) {
              if (!self.isWap) {
                newWindow.location = self.isForeshow === 2
                  ? '../2019/template/template/demand/release/Demand/PC/Default/html/onDemandInfo.html?instanceId=' + self.webinarInfo.Demand.enterShortUrl.replace(/[^0-9]/ig,"") + '&webinarId=' + self.webinarInfo.parentId //self.webinarInfo.Demand.enterShortUrl
                  : '../2019/template/template/newTemplate/release/Webinar/PC/Common/html/meetingInfo.html?instanceId=' + self.instanceId + '&webinarId=' + self.webinarInfo.webinarId //self.webinarInfo.enterShortUrl;
              } else {
                window.location.href = self.isForeshow === 2
               ? '../2019/template/template/demand/release/Demand/WAP/Default/html/onDemandInfo.html?instanceId=' + self.webinarInfo.Demand.wapUrl.replace(/[^0-9]/ig,"") + '&webinarId=' + self.webinarInfo.parentId //self.webinarInfo.Demand.wapUrl
              : '../2019/template/template/newTemplate/release/Webinar/WAP/Common/html/meetingInfo.html?instanceId=' + self.instanceId + '&webinarId=' + self.webinarInfo.webinarId //self.webinarInfo.wapUrl;
              }
            }
          });
        } else if (this.loginStatus === 1 && this.selectedStatus === 1) {
          if (!this.isWap) {
            window.open(this.isForeshow === 2
              ? '../2019/template/template/demand/release/Demand/PC/Default/html/onDemandInfo.html?instanceId=' + self.webinarInfo.Demand.enterShortUrl.replace(/[^0-9]/ig,"") + '&webinarId=' + self.webinarInfo.parentId //this.webinarInfo.Demand.enterShortUrl
              : '../2019/template/template/newTemplate/release/Webinar/PC/Common/html/meetingInfo.html?instanceId=' + self.instanceId + '&webinarId=' + self.webinarInfo.webinarId //this.webinarInfo.enterShortUrl
            );
          } else {//wapUrl
            window.location.href = this.isForeshow === 2
              ? '../2019/template/template/demand/release/Demand/WAP/Default/html/onDemandInfo.html?instanceId=' + self.webinarInfo.Demand.wapUrl.replace(/[^0-9]/ig,"") + '&webinarId=' + self.webinarInfo.parentId //self.webinarInfo.Demand.wapUrl
              : '../2019/template/template/newTemplate/release/Webinar/WAP/Common/html/meetingInfo.html?instanceId=' + self.instanceId + '&webinarId=' + self.webinarInfo.webinarId //self.webinarInfo.wapUrl;
          }
        }
      }
    }
  };
</script>

<style scoped lang="scss">
  .right-details-box {
    padding: 28px 32px;
    margin-top: 6px;
    background: #f7f7f7;
    position: relative;
  }

  .details-box {

  }
  .details-img{
    margin-top:10px;
  }
  .details-title {
    width: 100px;
    overflow: hidden;
    padding: 2px 0;

    &.Overview {
      width: 60px;
    }

    img {
      height: 19px;
      display: block;
    }
  }

  .details-centent {
    padding: 0 5px;
  }

  .details-centent dl {
    width: 100%;
    overflow: hidden;
    margin: 17px 0 0;
    display: flex;
  }

  .details-centent dl dt {
    flex: none;
    line-height: 24px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    text-align: center;
    color: #524f56;
    font-size: 15px;
    font-weight: bold;
  }

  .details-centent dl dd {
    line-height: 24px;
    color: #524f56;
    font-size: 15px;
    margin: 0;
  }

  .details-count-down {
    text-align: center;
    overflow: hidden;
    margin: 20px auto 0;
  }

  .details-count-down .timespan {
    display: inline-block;
    font-size: 15px;
    height: 36px;
    line-height: 36px;
    background-color: #f67e93;
    color: #fff;
    padding: 0 28px;
    letter-spacing: 1px;

    span {
      margin-left: 6px;
    }
  }

  .details-count-down .timespan-jrzb {
    background: #e90029;
    font-size: 15px;
    color: #f7f7f7;
    padding: 12px 50px;
    margin: 0;
    display: inline-block;
    border-radius: 2px;
    cursor: pointer;
  }

  .details-count-down .timespan-gkhf {
    background: #e90029;
    font-size: 15px;
    color: #f7f7f7;
    padding: 12px 50px;
    margin: 0;
    display: inline-block;
    border-radius: 2px;
    cursor: pointer;
  }

  .details-count-down .timespan-yjs span {
    font-size: 15px;
    display: inline-block;
    width: 160px;
    height: 36px;
    line-height: 36px;
    background-color: #ccc;
    color: #f7f7f7;
    letter-spacing: 1px;
  }

  .details-count-down .timespan-yjs p {
    text-align: center;
    font-size: 13px;
    color: #999999;
    margin: 10px auto 0;
  }

  .details-count-down span i {
    margin-left: 12px;
    font-style: normal;
  }

  .introduction-box {
    margin-top: 25px;
  }

  .details-introduction {
    padding: 5px;
    margin-top: 13px;
    background: url("../assets/icon-right-syh.png") left top no-repeat;
    text-indent: 25px;
    line-height: 24px;
    font-size: 15px;
    color: #524f56;
    text-align: justify;
    width: 100%;
    overflow: hidden;
  }

  .details-ktsImg{
    img{
      width: 100%;
    }
  }

  .toast-box {
    margin-top: 35px;
  }

  .toast-list {
    /*padding-bottom: 30px;*/
  }

  .toast-dl {
    width: 100%;
    overflow: hidden;
    margin: 17px 0 0;
    display: flex;
    align-items: center;
  }

  .toast-img {
    flex: 0 0 97px;
    padding: 5px 5px 0 0;
    background: url("../assets/icon-img-bj.png") right top no-repeat;
  }

  .toast-img img {
    display: block;
    border-radius: 50%;
    float: left;
    width: 92px;
    height: 92px;
    background: #ffffff;
  }

  .toast-text {
    flex: auto;
    margin-left: 23px;
  }

  .toast-text span {
    width: 100%;
    float: left;
    line-height: 24px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    text-align: left;
   /* margin-top: 20px;*/
    font-size: 18px;
    color: #524f45;
  }

  .toast-text p {
    width: 100%;
    margin: 10px 0 0;
    float: left;
    line-height: 24px;
    color: #524f56;
    font-size: 15px;
    text-align: left;
  }

  /* web */
  @media screen and (max-width: 750px) {
    .right-details-box {
      padding: pxToRem(30) pxToRem(26);
      margin: pxToRem(0) pxToRem(28);
    }
    .details-title {
      width: 100%;
      overflow: hidden;
      padding: pxToRem(4) 0;

      &.Overview {
        width: 100%;
      }

      img {
        height: pxToRem(28);
        display: block;
      }
    }
    .details-img {
      margin-top:pxToRem(10);
    }
    .details-img img{
      background-size:contain;
      width:100%;
      height: auto;
    }
    .details-centent {
      padding: 0 pxToRem(8);
    }
    .details-centent dl {
      margin: pxToRem(27) 0 0;
    }
    .details-centent dl dt {
      font-size: pxToRem(24);
      line-height: pxToRem(37);
    }
    .details-centent dl dd {
      font-size: pxToRem(24);
      line-height: pxToRem(37);
    }
    .details-count-down {
      margin: pxToRem(30) auto 0;
    }
    .details-count-down .timespan {
      font-size: pxToRem(26);
      height: pxToRem(68);
      line-height: pxToRem(68);
      background-color: #f67e93;
      color: #fff;
      padding: 0 pxToRem(22);
      letter-spacing: 1px;

      span {
        margin-left: pxToRem(12);
      }
    }
    .timespan-jrzb {
      padding: pxToRem(20) pxToRem(80) !important;
      font-size: pxToRem(26) !important;
    }
    .timespan-gkhf {
      padding: pxToRem(20) pxToRem(80) !important;
      font-size: pxToRem(26) !important;
    }
    .details-count-down .timespan-yjs span {
      display: inline-block;
      font-size: pxToRem(26);
      width: pxToRem(290);
      height: pxToRem(68);
      line-height: pxToRem(68);
      background-color: #ccc;
      color: #f7f7f7;
      padding: 0 pxToRem(22);
      letter-spacing: 1px;
    }
    .timespan-yjs p {
      font-size: pxToRem(18) !important;
      margin: pxToRem(13) auto 0 !important;
    }
    .details-introduction {
      background: url("../assets/web-icon-right-syh.png") left top no-repeat;
      background-size: pxToRem(44) pxToRem(38);
      text-indent: pxToRem(58);
      font-size: pxToRem(24);
      line-height: pxToRem(35);
      padding: pxToRem(5) pxToRem(24) pxToRem(18);
      margin-top: pxToRem(20);
    }
    .introduction-box {
      margin-top: pxToRem(45);
    }
    .toast-box {
      margin-top: pxToRem(45);
    }
    .toast-dl {
      margin-top: pxToRem(22);
    }
    .toast-img {
      flex: 0 0 pxToRem(150);
      background: url("../assets/web-icon-img-bj.png") right top no-repeat;
      height: pxToRem(142);
      padding: pxToRem(7) pxToRem(9);
      background-size: pxToRem(135) pxToRem(135);
    }
    .toast-img img {
      width: pxToRem(135);
      height: pxToRem(135);
    }
    .toast-text {
      margin-left: pxToRem(35);
    }
    .toast-text span {
      margin-top: pxToRem(30);
      font-size: pxToRem(26);
      line-height: pxToRem(35);
    }
    .toast-text p {
      margin-top: pxToRem(15);
      font-size: pxToRem(22);
      line-height: pxToRem(35);
    }
    .toast-list {
      padding-bottom: pxToRem(48);
      border: none;
    }
  }
</style>

<style lang="scss">
  ::-webkit-scrollbar
  {
    width: 5px;
  }

  /*定义滚动条轨道 内阴影+圆角*/
  ::-webkit-scrollbar-track
  {
    border-radius: 10px;
    background-color: rgba(0,0,0,0.1);
  }

  /*定义滑块 内阴影+圆角*/
  ::-webkit-scrollbar-thumb
  {
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3);
    background-color: rgba(0,0,0,0.1);
  }
  .details-introduction {
    img{
      width: auto;
      height:auto;
      max-height: 100%;
      max-width: 100%;
      -webkit-transform: scale(1) rotate(0) translate3d(0,0,0);transform: scale(1) rotate(0) translate3d(0,0,0)

    }
    p:last-child{
      display:inline;
    }
    p {
      margin: 0 0 10px 0;
    }

  }
</style>
